import React from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import './src/styles/index.css';

export const wrapRootElement = ({element}) => {
  const siteKey = process.env.GATSBY_RECAPTCHA_SITE_KEY;

  // Debug: Check if the site key is loaded
  if (!siteKey) {
    console.error('ReCaptcha site key is not defined!');
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}>
      {element}
    </GoogleReCaptchaProvider>
  );
};
